import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { AttachmentRebranded } from './AttachmentRebranded';

const useStyles = buildUseStyles('AttachmentsRebranded', (theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    display: 'flex',
    gap: theme.spacing(1),
  },
  rootDesktop: {
    flexWrap: 'wrap',
  },
  rootMobile: {
    overflow: 'scroll',
  },
}));

const AttachmentsRebranded = ({
  className,
  attachmentResources,
  AttachmentProps,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootDesktop]: !isMobile,
        [classes.rootMobile]: isMobile,
      })}
    >
      {attachmentResources.map((attachmentResource) => {
        return (
          <AttachmentRebranded
            key={attachmentResource.id()}
            attachmentResource={attachmentResource}
            {...AttachmentProps}
          />
        );
      })}
    </div>
  );
};

AttachmentsRebranded.defaultProps = {
  className: '',
  AttachmentProps: {},
};

AttachmentsRebranded.propTypes = {
  className: PropTypes.string,
  attachmentResources: PropTypes.array.isRequired,
  AttachmentProps: PropTypes.object,
};

export { AttachmentsRebranded };
